import axios from 'axios';
import authHeader from './auth-header';
import config from '../Config';

const API_URL = config.API_URL;
const API_VERSION = config.API_VERSION;

const getInquiryList = (page, pagesize, search, groupId, ordering) => {
  return axios.get(API_URL + '/api/' + API_VERSION + '/openinquiry/', {
    headers: authHeader(),
    params: {
      deleted: 0,
      page: page,
      pagesize: pagesize,
      search: search,
      die_group: groupId,
      ordering: ordering,
    },
  });
};
const getInquiryArchiveList = (page, pagesize, search, ordering) => {
  return axios.get(API_URL + '/api/' + API_VERSION + '/inq-archive-list/', {
    headers: authHeader(),
    params: {
      page: page,
      pagesize: pagesize,
      search: search,
      ordering: ordering,
    },
  });
};
const getInquiryById = id => {
  return axios.get(`${API_URL}/api/${API_VERSION}/openinquiry/${id}`, {
    headers: authHeader(),
  });
};

const addInquiry = formData => {
  return axios.post(
    `${API_URL}/api/${API_VERSION}/openinquiry/`,
    formData,
    { headers: authHeader() }
  );
};

const addOpenInquiry = formData => {
  return axios.post(
    `${API_URL}/api/${API_VERSION}/openinquiry/`,
    formData,
  );
};


const editInquiry = (id, formPayload) => {
  return axios.patch(
    `${API_URL}/api/${API_VERSION}/openinquiry/${id}/`, // Include the die group's ID in the URL
    formPayload, // Payload for the request body
    { headers: authHeader() },
  );
};

const deleteInquiry = id => {
  return axios.delete(
    `${API_URL}/api/${API_VERSION}/openinquiry/${id}/`,
    { headers: authHeader() }, // Authentication header
  );
};
const unArchiveInquiryRecord = id => {
  return axios.post(
    `${API_URL}/api/${API_VERSION}/openinquiry/${id}/unarchive/`, // Include the die group's ID in the URL
    {}, // Pass an empty object if no data needs to be sent
    { headers: authHeader() }, // Authentication header
  );
};

const deleteInquiryDetails = id => {
  return axios.delete(
    `${API_URL}/api/${API_VERSION}/openinquiry-details/${id}/`,
    { headers: authHeader() }, // Authentication header
  );
};

const assignedInquiry = (id, data) => {
  return axios.post(
    `${API_URL}/api/${API_VERSION}/openinquiry/${id}/assign/`,
    {assigned_user_id: data},
    { headers: authHeader() }
  );
};

const setFeasibleStatusData= (id, formPayload) => {
  return axios.patch(
    `${API_URL}/api/${API_VERSION}/openinquiry/${id}/feasible/`,
     formPayload,
    { headers: authHeader() }
  );
};

const assignInquiryRegrettedReason = (id, data) => {
  return axios.patch(
    `${API_URL}/api/${API_VERSION}/openinquiry/${id}/regret/`,
     data,
    { headers: authHeader() }
  );
};

const inquiryService = {
  getInquiryList,
  getInquiryArchiveList,
  getInquiryById,
  addInquiry,
  addOpenInquiry,
  editInquiry,
  deleteInquiry,
  unArchiveInquiryRecord,
  deleteInquiryDetails,
  assignedInquiry,
  setFeasibleStatusData,
  assignInquiryRegrettedReason
};
export default inquiryService;


